// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__14sbr","bulb":"Notification_bulb__1l8cP","seen":"Notification_seen__1u805"};